<template>
  <div style="width: 100%; margin: 0 auto;margin-top: 0.7rem;">
    <div v-if="!urlData.get('type')" class="SE_lb1"></div>
    <div v-if="urlData.get('type')" class="SE_lb"></div>
    <div class="SE_main" v-if="urlData.get('type')">
      <div class="SL_hotSongwriter">
        <div class="SL_hotSongwriter_title">在线课程</div>
        <div class="SL_hotSongwriter_click cur" @click="goPagelink('x-1')">
          查看全部
          <el-icon>
            <ArrowRightBold />
          </el-icon>
        </div>
      </div>
      <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 0.24rem;">
        <el-skeleton v-for="item in 8" :key="item" :loading="listData[0].loading" :throttle="{ trailing: 1000 }"
          :animated="true">
          <template #template>
            <el-skeleton-item variant="image" style="height: 1.58rem;" />
            <div style="padding: 14px">
              <el-skeleton-item variant="h3" style="width: 30%" />
              <el-skeleton-item variant="text" style="margin-right: 16px" />
            </div>
          </template>
        </el-skeleton>
        <div v-if="!listData[0].loading && listData[0].list"
          style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 0.24rem;">
          <moduleSEProvideMaterial v-for="item in listData[0].list" :key="item.id" :item="item"
            class="SL_offerMaterialListdiv cur">
          </moduleSEProvideMaterial>
        </div>
      </div>
      <div v-if="!listData[0].loading && !listData[0].list.length">
        <el-empty description="暂无数据" />
      </div>
      <div class="SL_hotSongwriter">
        <div class="SL_hotSongwriter_title">线下实战课</div>
        <div class="SL_hotSongwriter_click cur" @click="goPagelink('x-2')">
          查看全部
          <el-icon>
            <ArrowRightBold />
          </el-icon>
        </div>
      </div>
      <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 0.24rem;padding-bottom: .24rem;">
        <el-skeleton v-for="item in 8" :key="item" :loading="listData[1].loading" :throttle="{ trailing: 1000 }"
          :animated="true">
          <template #template>
            <el-skeleton-item variant="image" style="height: 1.58rem;" />
            <div style="padding: 14px">
              <el-skeleton-item variant="h3" style="width: 30%" />
              <el-skeleton-item variant="text" style="margin-right: 16px" />
            </div>
          </template>
        </el-skeleton>
        <div v-if="!listData[1].loading && listData[1].list"
          style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 0.24rem;">
          <moduleSEProvideMaterial v-for="item in listData[1].list" :key="item.id" :item="item"
            class="SL_offerMaterialListdiv cur">
          </moduleSEProvideMaterial>
        </div>
      </div>
      <div v-if="!listData[1].loading && !listData[1].list.length">
        <el-empty description="暂无数据" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const urlData = new URLSearchParams(location.search);
import { useRouter } from "vue-router";
import { ArrowRightBold } from "@element-plus/icons-vue"
import moduleSEProvideMaterial from "../../components/moduleSEProvideMaterial.vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
const router = useRouter();
const loading = ref(true);
const listData = ref([{
  value: 1,
  list: [],
  loading: false
}, {
  value: 2,
  list: [],
  loading: false
}])
document.title = "标识山西-培训";
const getList = (type) => {
  listData.value[type].loading = true;
  Axios(
    "get",
    "/system/courseWeb/list",
    {
      pageNum: 1,
      pageSize: 8,
      type: type == 0 ? 1 : 2
    },
    false,
    (res) => {
      if (res.data.code == 200) {
        listData.value[type].list = res.data.rows;
        setTimeout(() => {
          listData.value[type].loading = false;
        }, 1000);
      }
    }, () => {
      listData.value[type].list = [];
      setTimeout(() => {
        listData.value[type].loading = false;
      }, 1000);
    }
  );
}
getList(0)
getList(1)
// 跳列表页
const goPagelink = function (val) {
  router.push({
    path: "/ShadowTrainList",
    query: {
      type: val
    }
  });
};
</script>

<style scoped lang="less">
.SE_lb1 {
  position: relative;
  width: 100%;
  // height: 3.6rem;
  height: 7rem;
  background: url("../../assets/SE_lb1.d7ee88c8.png") no-repeat bottom center;
  /* background-size: auto 100%; */
  background-size: 100% 100%;
}

.SE_lb {
  position: relative;
  width: 100%;
  height: 3.6rem;
  /* height: 7rem; */
  background: url("../../assets/SE_lb.png") no-repeat bottom center;
  /* background-size: auto 100%; */
  background-size: 100% 100%;
}

/* .SE_lb>img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
} */

.SE_lb>div {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.SL_hotSongwriter {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 0.24rem;
  margin-bottom: 0.22rem;
  /* padding: 0.08rem; */
}

.SL_hotSongwriter_title {
  font-size: 0.24rem;
  color: #000;
}

.SL_hotSongwriter_click {
  font-size: 0.14rem;
  color: #333333;
  display: flex;
  align-items: center;
  column-gap: .04rem;
}

.SE_main {
  width: 12.8rem;
  margin: 0 auto;
}

.SL_offerMaterialListdiv {
  transition: all 0.5s;
  width: 3.02rem;
  position: relative;
  // margin-bottom: 0.3rem;
  display: block;
}
</style>
